import {API} from './api'
import {METHOD, request} from '@/utils/request'

/**
 * 添加字典说明
 * @param {*} data 
 * @returns 
 */
export function save(data){
    return request(API+'/define/insert', METHOD.POST, data)
}

/**
 * 更新字典说明
 * @param {*} data 
 * @returns 
 */
export function update(data){
    return request(API+'/define/update', METHOD.POST, data)
}

/**
 * 删除字典说明
 * @param {*} id 
 * @returns 
 */
export function del(id){
    return request(API+'/define/deleteById', METHOD.DELETE, undefined, {params:{id}})
}

/**
 * 查询全部字典定义
 * @returns 
 */
export function getAll(){
    return request(API+'/define/getAll', METHOD.GET)
}

/**
 * 添加字典内容
 * @param {*} data 
 * @returns 
 */
export function saveItem(data){
    return request(API+'/entry/insert', METHOD.POST, data)
}

/**
 * 更新字典内容
 * @param {*} data 
 * @returns 
 */
export function updateItem(data){
    return request(API+'/entry/update', METHOD.POST, data)
}

/**
 * 删除字典内容
 * @param {*} id 
 * @returns 
 */
export function delItem(id){
    return request(API+'/entry/deleteAllById', METHOD.DELETE, undefined, {params:{id}})
}

/**
 * 根据字典定义说明id查询字典项
 * @param {*} id 
 * @returns 
 */
export function getTreeByDicId(defineId){
    return request(API+'/entry/getTreeByDicId', METHOD.GET, undefined, {params:{defineId}})
}

/**
 * 根据字典定义说明code查询字典项
 * @param {*} id 
 * @returns 
 */
export function getTreeByCode(defineCode){
    return request(API+'/entry/getTreeByCode', METHOD.GET, undefined, {params:{defineCode}})
}

/**
 * 根据字典定义说明code及角色id查询字典树及选中状态
 * @param {*} roleId 
 * @param {*} defineCode 
 * @returns 
 */
export function getSelectedTreeByCode(roleId, defineCode){
    return request(API+'/entry/getSelectedTreeByCode', METHOD.GET, undefined, {params:{roleId,defineCode}})
}